<template>
<el-container class="login" direction="vertical">
  <el-header height="100px" class="header">
    <div style="display: flex; flex-direction: row; text-align: left;">
      <div style="padding: 0 5px 0 0">
        <i class="el-icon-document-copy icontitle" style="font-weight:bold;"></i>
      </div>
      <div style="padding-top: 5px; line-height: 25px">
        <div class="tit">{{SYS.subtitle}}</div>
        <div class="subtit">{{SYS.titledesc}}
        </div>
      </div>
    </div>
    <div style="font-size: 12px; color: #a0a0a0; padding: 20px">
      请使用谷歌、火狐、Microsoft Edge 等现代浏览器
    </div>
  </el-header>
  <el-main style="
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      ">
    <div style="
          line-height: 60px;
          text-align: left;
          padding: 0 20px 0 50px;
          color: #0062ab;
          font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande',
            'Lucida Sans', Arial, sans-serif;
        ">
      <h2 style="font-size: 25px">毕业设计</h2>
      <p style="font-size: 15px">让毕业设计变得更加轻松一点</p>
      <p style="font-size: 15px">
        <span class="numberfont">100+</span>院校的选择，<span class="numberfont">3000+</span>教师的利器，<span class="numberfont">30W+</span>学生的丝滑般体验！
      </p>
    </div>
    <el-card class="box-card">
      <div slot="header">
        <span>用户登陆</span>
      </div>
      <div style="
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          ">
        <div style="
              margin: 0 0 0 20px;
              padding: 30px;
              border-radius: 50%;
              background-color: #0062ab;
            ">
          <i class="el-icon-document-copy" style="font-size: 60px; color: white"></i>
        </div>
        <div>
          <el-form ref="form" label-width="80px" size="small" style="padding:10px;">
            <el-form-item label="院校代码:">
              <el-select v-model="sid" placeholder="请选择" size="small" style="display:block;">
                <el-option v-for="item in schools" :key="item.SNAME" :label="item.SNAME" :value="item.SID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户名称:">
              <el-input v-model="userName" placeholder="请输入用户编号"></el-input>
            </el-form-item>
            <el-form-item label="用户密码:">
              <el-input v-model="pwd" placeholder="请输入用户密码" type="password"></el-input>
            </el-form-item>
            <el-form-item label="用户角色:">
              <el-radio-group v-model="userClass" size="mini">
                <el-radio label="管理员"></el-radio>
                <el-radio label="专家"></el-radio>
                <el-radio label="导师"></el-radio>
                <el-radio label="学生"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button  type="primary" size="medium" @click="login">登陆</el-button>
              <el-button type="text" size="mini" @click="goResetPwd" style="margin-left: 20px;">忘记密码？</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>
  </el-main>
  <copyright></copyright>
</el-container>
</template>

<script>
import copyright from "@/components/copyright";
export default {
  components:{
    copyright
  },
  data() {
    return {
      schools: [],
      userClass: "学生",
      userName: "",
      pwd: "",
      sid: "",
    };
  },
  created() {
    this.getschool();
    if (this.CU.cu.spid == "0")
      this.sid = this.CU.cu.sid
    else
      this.sid = this.CU.cu.spid
    // this.userName = this.CU.cu.uid
    // this.pwd = this.CU.pwd
    if (this.CU.cu.uclass)
      this.userClass = this.CU.cu.uclass
    else
      this.userClass = "管理员";

  },
  methods: {
    getschool() {
      const that = this;
      
      this.GetData(
        "sys_school", {
          spid: "0"
        },
        function (res) {
          that.schools = res.data.data;
        },
        function (err) {}
      );
    },
    goResetPwd() {
    this.$router.push('/resetpassword');
  },
    login() {
      const that = this;
      if(!that.sid){
        that.$alert('请选择院校', {
            title: "错误"
          });
        return
      }
      that.LOGIN(
        that.userClass,
        that.sid,
        that.userName,
        that.pwd,
        function (res) {
          that.$router.replace("/main/welcome");
        },
        function (err) {
          console.log(err)
          that.$alert(err, {
            title: "错误"
          });
        }
      )
    },
  },
};
</script>

<!-- <style lang="less">
html,
body,
#app,
.homebox,
.el-container {
  padding: 0px;
  margin: 0px;
  height: 100%;
}
.header{
  // background-color: #c2c2c2;
  color: #0062ab;
}
.login {
  //background: url("~@/assets/loginbg1.jpg") no-repeat;
  background-size: cover;
}

.tit {
  
  font-size: 22px;
  font-weight: bold;
  // color: #0062ab;
}

.box-card {
  width: 600px;
  min-width: 600px;
  margin-right: 50px;
}

.el-header {
  height: 100px;
  padding: 10px 5px;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
}

.numberfont {
  font-size: 30px;
  color: darkred;
  font-weight: bold;
}
</style> -->
